import { writable } from 'svelte/store';

const createWritableStore = (key, startValue) => {
  const { subscribe, set, update } = writable(startValue);
  
	return {
    subscribe,
    set,
    update,
    useLocalStorage: () => {
      const json = localStorage.getItem(key);
      if (json) {
        set(JSON.parse(json));
      }
      
      subscribe(current => {
        localStorage.setItem(key, JSON.stringify(current));
      });
    }
  };
}

export const status = createWritableStore('status', {
    loggedIn: false,
    subscription: {},
    params: "",
    path: "/",
    notification: {
      show: false,
      confirm: false,
      text: "",
      title:"",
      buttonTextOk:"",
      buttonTextCancel:"",
      type: ""
    },
    message: {
      show: false,
      text: "",
      title:""
    },
    language: 0
});